
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.265 5.063a1.63 1.63 0 011.641 1.62V11c.434 0 .826.253 1.001.644.175.392.099.848-.194 1.164l-.174.188a2.2 2.2 0 01-1.615.703H7.007a2.032 2.032 0 01-1.832-1.14 1.063 1.063 0 01-.113-.48c0-.596.49-1.079 1.093-1.079V6.682c0-.894.735-1.62 1.641-1.62h5.47zm1.641 7.016h-8.75c.152.33.484.54.85.54h6.918c.307 0 .6-.127.807-.35l.175-.19zM8.87 3c.824 0 1.499.613 1.56 1.391H9.377a.518.518 0 00-.507-.386H1.565a.512.512 0 00-.522.502v4.02c0 .277.234.502.522.502h3.652v1.58c-.576 0-1.043.506-1.043 1.13 0 .106.013.208.038.304H3.13a.512.512 0 01-.521-.502c0-.277.233-.502.521-.502h.522v-1.005H1.565C.701 10.034 0 9.359 0 8.527v-4.02C0 3.675.7 3 1.565 3H8.87zm4.395 3.142H7.796a.543.543 0 00-.547.54V11h6.563V6.682a.543.543 0 00-.547-.54z"}})])
          )
        }
      }
    